var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#4B5EF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.002 10.002C41.0476 10.002 50.0018 18.9564 50.002 30.002C50.002 31.6566 49.8007 33.265 49.4219 34.8027H41.4395C42.0598 33.3263 42.4023 31.7038 42.4023 30.002C42.4022 23.1537 36.8502 17.6025 30.002 17.6025C23.1538 17.6027 17.6027 23.1538 17.6025 30.002C17.6025 36.8502 23.1537 42.4022 30.002 42.4023H45.6953C42.0322 47.0319 36.3638 50.002 30.002 50.002C18.9564 50.0018 10.002 41.0476 10.002 30.002C10.0021 18.9565 18.9565 10.0021 30.002 10.002ZM32.8037 25.2041C33.9082 25.2041 34.8037 26.0996 34.8037 27.2041V32.8037C34.8037 33.9082 33.9082 34.8037 32.8037 34.8037H27.2041C26.0996 34.8037 25.2041 33.9082 25.2041 32.8037V27.2041C25.2041 26.0995 26.0995 25.2041 27.2041 25.2041H32.8037Z",
    fill: "#F8F9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.042768c7e81d8d913e32204128e21233.svg";
export { ForwardRef as ReactComponent };